import { Typography } from '@material-ui/core'
import FlightLandIcon from '@material-ui/icons/FlightLand'

import { getTranslate } from '../../localization'
import useStyles from './styles/SearchWidgetArrivalDate.styles'

export type DATE = {
  data: { year: string; month: string; day: string }
}
const SearchWidgetArrivalDate: React.FC<DATE> = ({ data }) => {
  const classes = useStyles()
  const { year, month, day } = data

  return (
    <div className={classes.root}>
      <div className={classes.labelHeader}>
        <FlightLandIcon className={classes.icon} />
        <Typography variant="h4" className={classes.title}>
          {getTranslate('Arrival')}
        </Typography>
      </div>
      <div className={classes.dateContainer}>
        <div className={classes.dayContainer}>
          <Typography variant="h5" color="primary" className={classes.number}>
            {day}
          </Typography>
        </div>
        <div className={classes.monthContainer}>
          <Typography variant="h5" className={classes.title2}>
            {month} {year}
          </Typography>
        </div>
      </div>
    </div>
  )
}
export default SearchWidgetArrivalDate
